// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-text-field--outlined[data-v-11c98545] fieldset {\n  border-color: #c0cbe0 !important;\n}\n.v-text-field--outlined[data-v-11c98545] input::-moz-placeholder {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  letter-spacing: -0.02em;\n  color: #9fadc8;\n}\n.v-text-field--outlined[data-v-11c98545] input::placeholder {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  letter-spacing: -0.02em;\n  color: #9fadc8;\n}\n", ""]);
// Exports
module.exports = exports;
